import { html, LitElement } from 'lit-element';

import {
  createCorrectnessText,
  getPercentage,
  isMultiPartMER,
  latexToHTML,
} from './utils.js';

/**
 * @element header-block-multi-item
 * @prop {Object} item - Item
 * @prop {Object} session - session
 * @prop {Object} studentsNumber - students Number
 * @prop {Number} studentsAnsweredNr - The number of all the student that answered the question
 */
export class HeaderBlockMultiItem extends LitElement {
  static get properties() {
    return {
      item: { type: Object, attribute: false },
      studentsNumber: { type: Number, attribute: false },
      studentsAnsweredNr: { type: Number, attribute: false },
      session: { type: Number, attribute: false },
    };
  }

  createRenderRoot() {
    return this;
  }

  _openDetails() {
    const studentsNr = this.studentsNumber || 0;
    const studentsAnsweredNr = this.studentsAnsweredNr || 1;

    const content = html`<view-details-modal-multi-item
      .response=${{
        item: this.item,
        studentsNr,
        studentsAnsweredNr,
      }}
    ></view-details-modal-multi-item>`;

    window.dispatchEvent(
      new CustomEvent('classroom-tool-live-open-modal', {
        detail: {
          modalContent: content,
          modalType: 'view-details-modal-multi-item',
          modalTitle: html`<p><strong>Details</strong></p>`,
        },
      })
    );
  }

  _openRationale() {
    const { models } = this.item || {};

    // we only display the first rationale for MER multi-items
    const content = html`<rationale-modal
      .rationale=${models[0].rationale}
    ></rationale-modal>`;

    window.dispatchEvent(
      new CustomEvent('classroom-tool-live-open-modal', {
        detail: {
          modalContent: content,
          modalType: 'rationale-modal',
        },
      })
    );
  }

  correctResponsesMER() {
    const { models } = this.item || {};

    return models
      .map(model => {
        const { responses } = model;

        return responses && responses[0] && responses[0].answer;
      })
      .join(', ');
  }

  render() {
    const isMER = isMultiPartMER(this.item);
    const studentsNr = this.studentsNumber || 0;
    const percentage = getPercentage(
      this.studentsNumber,
      this.studentsAnsweredNr
    );

    const { autoScore, manualScore, correctnessGroup } = this.session || {};
    const { points } = autoScore || manualScore || {};
    const correctness = correctnessGroup || 'unanswered';
    const correctnessText = createCorrectnessText(points);

    return html` <div class="header-block">
      <div class="block">
        <div class="header-correct-response">
          <div class="header-correct-response-selection ${correctness}">
            ${correctnessText}
          </div>
          ${correctness === 'correct' && isMER
            ? html`<div
                class="header-correct-response-value header-correct-response-value-math"
              >
                <math-rendering-element
                  .label="${latexToHTML(this.correctResponsesMER())}"
                ></math-rendering-element>
                <div class="header-correct-response-value-overflow"></div>
                <div
                  class="header-correct-response-value-bottom-overflow"
                ></div>
              </div>`
            : null}
        </div>

        <div class="more">
          ${correctness === 'correct'
            ? html`<button class="more-button" @click=${this._openDetails}>
                  <span>View Details</span>
                </button>
                <button class="more-button" @click=${this._openRationale}>
                  ${isMER ? html`<span>Rationale</span>` : null}
                </button>`
            : null}
        </div>
      </div>

      <div class="block header-students-number">
        ${studentsNr} Student${studentsNr === 1 ? '' : 's'} (${percentage}%)
      </div>
    </div>`;
  }
}

export default HeaderBlockMultiItem;
